import { Component, OnInit } from '@angular/core';
import { ChatbotService } from '../../services/chatbot.service';

@Component({
  selector: 'app-chatbot-fab',
  templateUrl: './chatbot-fab.component.html',
  styleUrls: ['./chatbot-fab.component.css']
})
export class ChatbotFabComponent implements OnInit {

  open = true;
  messages: any[] = [];
  newMessage = '';
  isLoading = false;
  fontSize = 14; // Default font size
  showGuidebook = false;

  // Guidebook content
  guideCommands = [
    'Ask questions about company data',
    'Ask for meeting schedules [example: "schedule a {meeting-type} meeting on {date} at {time}"]',
    'Get Company Secretary information'
  ];

  constructor(private chatbotService: ChatbotService) {
    console.log('ChatbotFabComponent constructor called');
  }

  ngOnInit(): void {
    console.log('ChatbotFabComponent ngOnInit called');
  }

  toggleChat() { 
    this.open = !this.open; 
    console.log('FAB Chat toggled:', this.open);
  }

  // Font size controls
  increaseFontSize() {
    if (this.fontSize < 20) {
      this.fontSize += 2;
    }
  }

  decreaseFontSize() {
    if (this.fontSize > 10) {
      this.fontSize -= 2;
    }
  }

  // Toggle guidebook
  toggleGuidebook() {
    this.showGuidebook = !this.showGuidebook;
  }

  // Clear chat
  clearChat() {
    this.messages = [];
    console.log('FAB Chat cleared');
  }

  send() {
    if(this.newMessage.trim()) {
      const userMessage = this.newMessage.trim();
      
      // Add user message to chat
      this.messages.push({ role: 'user', content: userMessage });
      console.log('FAB Message sent:', userMessage);
      
      // Clear input and show loading
      this.newMessage = '';
      this.isLoading = true;
      
      // Call chatbot API
      this.chatbotService.sendMessage(userMessage)
        .then((response) => {
          console.log('FAB Chatbot response:', response);

          const botMessage = response.response || response.message || 'Sorry, I could not process your request.';
          this.messages.push({ role: 'bot', content: botMessage });
          this.isLoading = false;
        })
        .catch((error) => {
          console.error('FAB Chatbot error:', error);
          this.messages.push({ 
            role: 'bot', 
            content: 'Sorry, I encountered an error while processing your request. Please try again later.' 
          });
          this.isLoading = false;
        });
    }
  }
}
